// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:54:25

export default {
  "id": "spin-spin",
  "slug": "spin-spin",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/78f2c8d27bde4c1cbd53de38b3875c26-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/78f2c8d27bde4c1cbd53de38b3875c26/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Spin Spin",
      "description": "Connect positive and negative battery terminals in an alternating pattern (positive, negative, positive…) to complete the circuit and power up!",
      "instructions": "Drag and drop",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "computer",
        "drag"
      ]
    },
    "zh-CN": {
      "title": "旋转旋转",
      "description": "将正负电池端子交替连接（正、负、正...）以完成电路并供电！",
      "instructions": "拖放",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "2D",
        "电脑",
        "拖拽"
      ]
    },
    "zh-TW": {
      "title": "旋轉旋轉",
      "description": "將正負電池端子以交錯模式連接（正、負、正…）以完成電路並開啟電源！",
      "instructions": "拖放",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "電腦",
        "拖曳"
      ]
    },
    "zh-HK": {
      "title": "旋轉旋轉",
      "description": "將正極及負極電池端子以交替模式（正極、負極、正極……）連接，以完成電路並啟動電力！",
      "instructions": "拖放",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人遊玩",
        "2D",
        "電腦操控",
        "拖移"
      ]
    },
    "ja": {
      "title": "スピン スピン",
      "description": "正と負のバッテリー端子を交互に接続して（正、負、正…）回路を完成させ、電源をオンに！",
      "instructions": "ドラッグ＆ドロップ",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "コンピュータ",
        "ドラッグ"
      ]
    },
    "ko": {
      "title": "스핀 스킨",
      "description": "양성과 음성 배터리 테르미널을 교차로 연결하여 회로를 완성하고 전원을 켜세요! (양성, 음성, 양성...)",
      "instructions": "드래그 앤 드롭",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "컴퓨터",
        "드래그"
      ]
    },
    "fr": {
      "title": "Faites tourner Faites tourner",
      "description": "Connectez les bornes positives et négatives de la batterie en alternance (positive, négative, positive...) pour complêter le circuit et allumer !",
      "instructions": "Glisser-déposer",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "ordinateur",
        "glisser"
      ]
    }
  }
};
